// extracted by mini-css-extract-plugin
export default {"container":"OrganizationInfo_container__FFDtm","organizationIconContainer":"OrganizationInfo_organizationIconContainer__cFxXj","orgInfoList":"OrganizationInfo_orgInfoList__+iMey"};